import { GenerationCounter } from "~/solidJs/shared/helpers";

export const generationCounter = new GenerationCounter(["qustionsCounter"] as const, 0);
